import React from 'react';
import { Users, TrendingUp, Eye, BarChart3 } from 'lucide-react';

const AnalyticsTab = ({ analyticsData }) => (
  <div className="analytics-section" data-testid="analytics-dashboard">
    <div className="analytics-cards">
      <div className="analytics-card">
        <Eye size={22} />
        <div className="analytics-card-data">
          <span className="analytics-card-value">{analyticsData?.page_views || 0}</span>
          <span className="analytics-card-label">Page Views</span>
        </div>
      </div>
      <div className="analytics-card">
        <Users size={22} />
        <div className="analytics-card-data">
          <span className="analytics-card-value">{analyticsData?.unique_visitors || 0}</span>
          <span className="analytics-card-label">Unique Visitors</span>
        </div>
      </div>
      <div className="analytics-card">
        <TrendingUp size={22} />
        <div className="analytics-card-data">
          <span className="analytics-card-value">{analyticsData?.conversions || 0}</span>
          <span className="analytics-card-label">Conversions</span>
        </div>
      </div>
      <div className="analytics-card accent">
        <BarChart3 size={22} />
        <div className="analytics-card-data">
          <span className="analytics-card-value">{analyticsData?.conversion_rate || 0}%</span>
          <span className="analytics-card-label">Conversion Rate</span>
        </div>
      </div>
    </div>

    {analyticsData?.daily_views?.length > 0 && (
      <div className="analytics-panel">
        <h3 className="section-heading">Page Views Harian</h3>
        <div className="daily-chart">
          {analyticsData.daily_views.map((d, i) => {
            const max = Math.max(...analyticsData.daily_views.map(v => v.views));
            const height = max > 0 ? (d.views / max) * 100 : 0;
            return (
              <div key={i} className="chart-bar-wrap" title={`${d.date}: ${d.views} views`}>
                <div className="chart-bar" style={{ height: `${Math.max(height, 4)}%` }}><span className="chart-bar-label">{d.views}</span></div>
                <span className="chart-date">{d.date.slice(5)}</span>
              </div>
            );
          })}
        </div>
      </div>
    )}

    {analyticsData?.top_clicks?.length > 0 && (
      <div className="analytics-panel">
        <h3 className="section-heading">Element Paling Diklik</h3>
        <div className="click-list">
          {analyticsData.top_clicks.map((c, i) => (
            <div key={i} className="click-item">
              <span className="click-rank">{i + 1}</span>
              <span className="click-name">{c.element}</span>
              <span className="click-count">{c.count}x</span>
            </div>
          ))}
        </div>
      </div>
    )}

    {analyticsData?.scroll_depths?.length > 0 && (
      <div className="analytics-panel">
        <h3 className="section-heading">Scroll Depth</h3>
        <div className="scroll-bars">
          {analyticsData.scroll_depths.map((s, i) => {
            const max = Math.max(...analyticsData.scroll_depths.map(v => v.count));
            const width = max > 0 ? (s.count / max) * 100 : 0;
            return (
              <div key={i} className="scroll-bar-row">
                <span className="scroll-label">{s.depth}%</span>
                <div className="scroll-bar-track"><div className="scroll-bar-fill" style={{ width: `${width}%` }}></div></div>
                <span className="scroll-count">{s.count}</span>
              </div>
            );
          })}
        </div>
      </div>
    )}

    {analyticsData?.event_types?.length > 0 && (
      <div className="analytics-panel">
        <h3 className="section-heading">Event Breakdown</h3>
        <div className="data-table">
          <table>
            <thead><tr><th>Event Type</th><th>Count</th></tr></thead>
            <tbody>{analyticsData.event_types.map((e, i) => (<tr key={i}><td>{e.type}</td><td>{e.count}</td></tr>))}</tbody>
          </table>
        </div>
      </div>
    )}

    {!analyticsData?.total_events && (
      <div className="scheduler-empty">
        <BarChart3 size={48} />
        <p>Belum ada data analytics.</p>
        <p className="scheduler-hint">Data akan mulai muncul setelah pengunjung mengakses landing page.</p>
      </div>
    )}
  </div>
);

export default AnalyticsTab;
